import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { useState } from "react";
import PasswrdStrenthBar from "react-password-strength-bar";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import {
  NewPasswordChange,
  setPageName,
  setLoginStateParams,
} from "../../Redux/Actions/webAppActions";
import history from "../../Utils/History";
import Footer1 from "../../Utils/GenericUI/Footer1";
import FooterContainer from "../Footer/FooterContainer";
const PwdResetPage = (props) => {
  const [pswd, setpswd] = useState("");
  const [cnfpswd, setcnfpswd] = useState("");
  const [showPswd, setshowPswd] = useState(false);
  const [showConfirmPswd, setshowConfirmPswd] = useState(false);
  const [textColor, settextColor] = useState("#ef4836");
  const [textColor1, settextColor1] = useState("#ef4836");
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [snackBarMsg, setsnackBarMsg] = useState("");
  const [vertical, setvertical] = useState("top");
  const [horizontal, sethorizontal] = useState("center");
  const [severity, setseverity] = useState("error");
  const [isVerified, setVerified] = useState(false);
  const handleChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "password") {
      setpswd(value);
    }
    if (name === "confirmPassword") {
      setcnfpswd(value);
    }
  };
  React.useEffect(() => {
    props.setPageName("resetpassword");
    props.setLoginStateParams("isResetPwd", true);
  }, []);
  const handleForgetPwd = async () => {
    if (!pswd) {
      setsnackBarOpen(true);
      setvertical("top");
      sethorizontal("center");
      setsnackBarMsg("please Enter Password.");
      return;
    }
    let pattern = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
    );
    if (!pattern.test(pswd) || pswd.length < 8) {
      setsnackBarOpen(true);
      setsnackBarMsg(
        "password must be atleast 8 or more characters with a mix of upper & lowercase, numbers & Special Character!"
      );
      return;
    }
    if (!cnfpswd) {
      setsnackBarOpen(true);
      setsnackBarMsg("please Enter Confirm Password.");
      return;
    }
    if (pswd !== cnfpswd) {
      setsnackBarOpen(true);
      setsnackBarMsg("Passwords do not match, please re-enter.");
      return;
    }

    const response = await props.NewPasswordChange({
      userId: window.location.href.split("/")[5],
      newPwd: pswd,
      customerId: props?.customerId,
    });
    if (response?.message === "SUCCESS") {
      if (response.data === "Password cannot be same as old password") {
        setpswd("");
        setcnfpswd("");
        setsnackBarOpen(true);
        setseverity("error");
        setsnackBarMsg(response?.data);
        setVerified(false);
      } else {
        setVerified(true);
      }
    } else {
      setVerified(false);
      let msg = response?.data?.message;
      let url = "/e-Enroll/Err-Page?msg=" + msg;
      history.push(url);
    }
  };
  const onChangeScore = (scroe) => {
    settextColor(
      scroe === 1
        ? "#ef4836"
        : scroe === 2
        ? "#f6b44d"
        : scroe === 3
        ? "#2b90ef"
        : scroe === 4
        ? "#25c281"
        : "#ef4836"
    );
  };
  const onChangeScore1 = (scroe) => {
    settextColor1(
      scroe === 1
        ? "#ef4836"
        : scroe === 2
        ? "#f6b44d"
        : scroe === 3
        ? "#2b90ef"
        : scroe === 4
        ? "#25c281"
        : "#ef4836"
    );
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
    setseverity("error");
  };
  return (
    <div>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        {
          <Alert onClose={handleClose} severity={severity}>
            {snackBarMsg}
          </Alert>
        }
      </Snackbar>
      {!isVerified ? (
        <div class="reset-container justify-content-center container">
          <div style={{ paddingTop: "110px" }}>
            <h3>Reset Password</h3>
            <div className="p-2">
              <div class="pb-2 col-sm-12 col-md-12 col-lg-12">
                <TextField
                  label=" Email Address*"
                  variant="outlined"
                  type="email"
                  name="email"
                  size="small"
                  style={{ backgroundColor: "#ffffff" }}
                  fullWidth
                  value={window.location.href.split("/")[5]}
                  onChange={handleChange}
                  disabled={true}
                  inputProps={{
                    autoComplete: "off",
                    spellcheck: "false",
                    "aria-autocomplete": "both",
                    "aria-haspopup": "false",
                  }}
                />
              </div>
              <div class="pb-2 col-sm-12 col-md-12 col-lg-12">
                <div style={{ position: "relative" }}>
                  <TextField
                    label="New Password*"
                    variant="outlined"
                    class="textstyle"
                    type={showPswd ? "text" : "password"}
                    id="password"
                    name="password"
                    fullWidth
                    size="small"
                    value={pswd}
                    onChange={handleChange}
                    inputProps={{
                      autoComplete: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "both",
                      "aria-haspopup": "false",
                    }}
                  />
                  {showPswd ? (
                    <div
                      class="eyeIcon-password bottom-8px"
                      onMouseDown={() => setshowPswd(!showPswd)}
                    >
                      <RemoveRedEyeIcon style={{ marginRight: "9px" }} />
                    </div>
                  ) : (
                    <div
                      class="eyeIcon-password bottom-8px"
                      onMouseDown={() => setshowPswd(!showPswd)}
                    >
                      <VisibilityOffIcon style={{ marginRight: "9px" }} />
                    </div>
                  )}
                </div>

                <div style={{ width: "100%" }}>
                  {pswd.length > 0 ? (
                    <PasswrdStrenthBar
                      password={pswd}
                      scoreWordStyle={{
                        color: textColor,
                        fontWeight: 600,
                        fontSize: "1rem",
                      }}
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        flexWrap: "wrap",
                        minWidth: 0,
                      }}
                      minLength={8}
                      onChangeScore={onChangeScore}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div></div>
              </div>
              <div class="pb-2 col-sm-12 col-md-12 col-lg-12">
                <div style={{ position: "relative" }}>
                  <TextField
                    label="Confirm New Password*"
                    variant="outlined"
                    class="textstyle"
                    type={showConfirmPswd ? "text" : "password"}
                    id="confirmPassword"
                    fullWidth
                    name="confirmPassword"
                    size="small"
                    value={cnfpswd}
                    onChange={handleChange}
                    inputProps={{
                      autoComplete: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "both",
                      "aria-haspopup": "false",
                    }}
                  />
                  {showConfirmPswd ? (
                    <div
                      class="eyeIcon-confirm-password bottom-8px"
                      onMouseDown={() =>
                        setshowConfirmPswd(!showConfirmPswd)
                      }
                    >
                      <RemoveRedEyeIcon
                        style={{ marginRight: "9px" }}
                        onClick={() =>
                          setshowConfirmPswd(!showConfirmPswd)
                        }
                      />
                    </div>
                  ) : (
                    <div
                      class="eyeIcon-confirm-password bottom-8px "
                      onMouseDown={() =>
                        setshowConfirmPswd(!showConfirmPswd)
                      }
                    >
                      <VisibilityOffIcon style={{ marginRight: "9px" }} />
                    </div>
                  )}
                </div>

                <div>
                  <div style={{ width: "100%" }}>
                    {cnfpswd.length > 0 ? (
                      <PasswrdStrenthBar
                        password={cnfpswd}
                        scoreWordStyle={{
                          color: textColor1,
                          fontWeight: 600,
                          fontSize: "1rem",
                        }}
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          flexWrap: "wrap",
                          minWidth: 0,
                        }}
                        minLength={8}
                        onChangeScore={onChangeScore1}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <button
                  class="btn-primary-continue"
                  id="forgetPwd"
                  onClick={handleForgetPwd}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="global-err-container">
            <p>
              your password has been reset successfully, please click on
              <a
                className="err-link"
                onClick={() => {
                  history.push("/e-Enroll/login");
                  props.setLoginStateParams("isResetPwd", false);
                }}
              >
                {" "}
                sign in{" "}
              </a>
              to login with your new password.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    email: state.login.emailAddress,
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  NewPasswordChange,
  setPageName,
  setLoginStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(PwdResetPage);
